<script setup>
import Overlay from '@/assets/js/src/components/Overlay.vue'
import PartnerList from '@/assets/js/src/modules/partner/_components/PartnerList.vue'
import { usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import LoadingDummyP from '@/assets/js/src/components/loading/LoadingDummyP'
import H1Title from '@/assets/js/src/components/overlay/H1Title.vue'
import { useHeadInfoTitle, } from '@/assets/js/src/layout/useHeadInfo'
import { useTranslation, } from '@/assets/js/src/util/composables'

const { messagesLoaded, } = usePrefetchData({
    loadAsyncMessages: [ 'partner', 'common', ],
})

useHeadInfoTitle({
    titleKey: 'async.partner.meta_title',
})

const { t, } = useTranslation()
</script>

<template>
    <overlay
        full-width
        class-name="partner-view"
    >
        <v-row>
            <v-col
                cols="12"
                md="6"
                offset-md="3"
            >
                <h1-title title-key="async.partner.title" />

                <div
                    v-if="messagesLoaded"
                    v-html="t('async.partner.description')"
                ></div>
                <template
                    v-else
                >
                    <loading-dummy-p :count="4"></loading-dummy-p>
                </template>
            </v-col>
        </v-row>
        <partner-list></partner-list>
    </overlay>
</template>

<style lang="scss">
.bs-app .partner-view .partner-list {
    margin: 0 -#{map-deep-get($bs-xl, overlay, grid, margin)};
    padding: 0 map-deep-get($bs-xl, body, paddingX);

    @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
        padding: 0;
    }
}
</style>
